import {Button, Dialog, DialogContent, useMediaQuery} from "@mui/material";
import {getUserInfo} from "../../util/author";
import React, {useState} from "react";
import {useMatomoTrackingPoint} from "../../hooks/useMatomoTrackingPoint";
import Login from "../../pages/login";
import {LoginProps} from "../../types/authority";
import {setUserInfo} from "../../store/userSlice";
import {AppDispatch} from "../../store";
import {useDispatch} from "react-redux";
import {getLocalStorage} from "../../util/storage";

export default function NewUser(props:{register_from: string}) {

    const {register_from} = props

    const userInfo = getUserInfo()

    const [openLoginDialog, setOpenLoginDialog] = useState<boolean>(false)

    const [templateType, setTemplateType] = useState<'login' | 'register' | 'code' | 'reset'>('register')

    const {trackHomeRegisterClick, trackVisitorChatBoxClick, trackRegisterPopupShow, trackHomeLoginClick} = useMatomoTrackingPoint()

    const dispatch: AppDispatch = useDispatch();
    const isMobile = useMediaQuery('(max-width: 768px)');

    const changeDialogLoading = (open: boolean) => {
        setOpenLoginDialog(open)
    }

    const handleSetUserInfo = (data: LoginProps | null) => {
        dispatch(setUserInfo(data))
    }

    return <div style={{position: 'absolute', top: '10px', right: '10px', zIndex: 999}}>
        <Dialog
            open={openLoginDialog}
            onClose={()=>{setOpenLoginDialog(false)}}
            fullScreen={isMobile}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: 'none',
                    borderRadius: isMobile ? '0px' : "20px"
                },
                '& .MuiDialogContent-root': {
                    padding: '0',
                }
            }}
        >
            <DialogContent>
                <div className="login-dialog-content">
                    <Login changeDialogLoading={changeDialogLoading} handleSetUserInfo={handleSetUserInfo} templateTypeProps={templateType} />
                </div>
            </DialogContent>
        </Dialog>
        <div style={{marginRight: 10, display: !userInfo ? 'block' : 'none'}}>
            <Button
                variant="outlined"
                sx={{
                    backgroundColor: 'var(--c-bg-secondary)',
                    color: 'var(--c-text-primary)',
                    borderColor: 'var(--c-text-secondary)',
                    marginRight: '10px',
                    display: 'none'
                }}
                onClick={() => {
                    setOpenLoginDialog(true)
                    setTemplateType('register')
                }}
            >
                登录
            </Button>
            <Button
                variant="contained"
                sx={{
                    backgroundColor: 'var(--c-violet-soft)',
                    color: 'var(--c-on-color)',
                }}
                onClick={() => {
                    trackHomeLoginClick()
                    trackRegisterPopupShow({register_from, device_id: getLocalStorage('device_id') || undefined,})
                    setOpenLoginDialog(true)
                    setTemplateType('register')
                }}
            >
                免费开始
            </Button>
        </div>
    </div>
}